var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ModelNumber;
(function (ModelNumber) {
    ModelNumber["mxa1502"] = "-Ne3a5r-rc68g1Ipt6k1";
    ModelNumber["aqm1208"] = "-Nx3Qa8wDTBUvYR7tN6S";
})(ModelNumber || (ModelNumber = {}));
export class AshlyMxaDsp {
    constructor(log) {
        this.channelConfigurations = {
            [ModelNumber.mxa1502]: {
                // 12 x 2 amp, 2 line outputs
                input: {
                    start: 1,
                    end: 8,
                    idPrefix: 'InputChannel',
                    namePrefix: 'Mic In',
                    type: 'Mic/Line Input',
                    baseType: 'Input',
                },
                stereoInput: {
                    start: 9,
                    end: 12,
                    idPrefix: 'InputChannel',
                    namePrefix: 'Stereo In',
                    type: 'Stereo Input',
                    baseType: 'Input',
                },
                ampOutput: {
                    start: 1,
                    end: 2,
                    idPrefix: 'OutputChannel',
                    namePrefix: 'Speaker Out',
                    type: 'Amplifier Output',
                    baseType: 'Output',
                },
                lineOutput: {
                    start: 3,
                    end: 4,
                    idPrefix: 'OutputChannel',
                    namePrefix: 'Aux Out',
                    type: 'Auxiliary Line Output',
                    baseType: 'Output',
                },
                preset: {
                    start: 1,
                    end: 4, // Only define 4 presets for emulator
                },
                subMix: {
                    start: 1,
                    end: 4,
                },
            },
            [ModelNumber.aqm1208]: {
                // 12x8 mixer
                input: {
                    start: 1,
                    end: 12,
                    idPrefix: 'InputChannel',
                    namePrefix: 'Mic In',
                    type: 'Mic/Line Input',
                    baseType: 'Input',
                },
                lineOutput: {
                    start: 1,
                    end: 8,
                    idPrefix: 'OutputChannel',
                    namePrefix: 'Out',
                    type: 'Line Output',
                    baseType: 'Output',
                },
                preset: {
                    start: 1,
                    end: 16,
                },
                subMix: {
                    start: 1,
                    end: 8,
                },
            },
        };
        this.dspChannels = [];
        this.dspBlockDefinitions = [];
        this.mixerConfig = {};
        this.inputOutputMutes = {};
        this.blockLevels = {};
        this.modelNumber = ModelNumber.mxa1502;
        this.powerState = true;
        this.presets = [];
        this.asyncHandlers = [
            {
                name: 'channelsInputOutputGet',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/workingsettings\/dsp\/channel$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: this.dspChannels,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'channelsDspBlockGet',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/workingsettings\/dsp\/block$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: this.dspBlockDefinitions,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'channelsMixersGet',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/workingsettings\/dsp\/mixer\/config\/parameter$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: Object.values(this.mixerConfig),
                    };
                    return { data: response };
                }),
            },
            {
                name: 'dspBlockGainSet',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/workingsettings\/dsp\/block\/parameter\/(.+)$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const params = JSON.parse(req.data);
                    const key = match[1];
                    if (key in this.blockLevels) {
                        this.blockLevels[key] = parseInt(params.value, 10);
                    }
                    const response = {
                        success: true,
                        data: { value: params.value }, // return as string
                    };
                    return { data: response };
                }),
            },
            {
                name: 'inputOutputMutes',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/workingsettings\/dsp\/chain\/mute\/$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // create Mute status
                    const mutes = [];
                    for (const [key, muteInfo] of Object.entries(this.inputOutputMutes)) {
                        mutes.push({ id: key, muted: muteInfo.muted });
                    }
                    const response = {
                        success: true,
                        data: mutes,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'sourceMutesAndLevels',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/workingsettings\/dsp\/mixer\/sourceMutesAndLevels$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const crossPointValues = [];
                    for (const crossPoint of Object.values(this.mixerConfig)) {
                        if (crossPoint.DSPMixerConfigParameterTypeId === 'Mixer.Source Mute' ||
                            crossPoint.DSPMixerConfigParameterTypeId === 'Mixer.Source Level') {
                            // This response uses SourceMute and SourceLevel field names
                            const myValue = {
                                id: crossPoint.id
                                    .replace('Source Mute', 'SourceMute')
                                    .replace('Source Level', 'SourceLevel'),
                                value: crossPoint.value,
                            };
                            crossPointValues.push(myValue);
                        }
                    }
                    const response = {
                        success: true,
                        data: crossPointValues,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'blockGainQuery',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/workingsettings\/dsp\/block\/gain\/level$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // create Mute status
                    const blockGains = [];
                    for (const [key, gain] of Object.entries(this.blockLevels)) {
                        blockGains.push({ id: key, value: gain });
                    }
                    const response = {
                        success: true,
                        data: blockGains,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'login',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/session\/login/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    var _a;
                    const params = Object.fromEntries(((_a = req.data) !== null && _a !== void 0 ? _a : '')
                        .trim()
                        .split(',')
                        .filter(s => s.includes(':'))
                        .map(s => s.split(':')));
                    const response = {
                        success: true,
                        data: [
                            {
                                loggedIn: true,
                                enabledPermissions: [
                                    'View Accounts',
                                    'Edit Accounts',
                                    'Remote Logout',
                                    'View Device Misc.',
                                    'Edit Device Misc.',
                                    'View All DSP settings',
                                    'Event Log View',
                                    'Event Log Clear',
                                    'Event Scheduler View',
                                    'Event Scheduler Edit',
                                    'Front Panels Control View',
                                    'Front Panels Control Edit',
                                    'Network Settings View',
                                    'Network Settings Edit',
                                    'Paging Ducking View',
                                    'Paging Ducking Edit',
                                    'Preset View',
                                    'Preset Edit',
                                    'Preset Recall',
                                    'DCA Remote',
                                    'Mixer 1 Remote',
                                    'Mixer 2 Remote',
                                    'Mixer 3 Remote',
                                    'Mixer 4 Remote',
                                    'System Time View',
                                    'System Time Edit',
                                    'Trigger Settings View',
                                    'Trigger Settings Edit',
                                    'Update Firmware Run',
                                    'Rear Panel Controls View',
                                    'Rear Panel Controls Edit',
                                    'Edit Signal Chain',
                                    'Change Password',
                                    'Import/Export Settings',
                                    'View Remotes',
                                    'Edit Remotes',
                                    'Add Remotes',
                                ],
                                enabledRemotePermissions: [],
                                lastLogin: 'Sat Aug 26 2023, 15:01:06 GMT-0400 (Eastern Daylight Time)',
                                uniqueId: 'e90da560-4442-11ee-9f71-f3ed14ab0bff',
                                keepLoggedIn: params.keepLoggedIn === 'true',
                            },
                        ],
                    };
                    return { data: response };
                }),
            },
            {
                name: 'setMuteChannel',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/workingsettings\/dsp\/chain\/mute\/(.+)$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const params = JSON.parse(req.data);
                    const key = match[1];
                    const muteValue = params.muted;
                    if (key in this.inputOutputMutes) {
                        this.inputOutputMutes[key] = { id: key, muted: muteValue };
                        return {
                            data: {
                                success: true,
                                data: {
                                    id: key,
                                    isWorkingSettings: true,
                                    muted: muteValue,
                                    mixerId: null,
                                    DSPChannelId: key,
                                    presetId: null,
                                },
                            },
                        };
                    }
                    return {
                        data: {
                            statusCode: 422,
                            error: 'Unprocessable Entity',
                            message: `(Error Code: undefined ) Error, supplied channel id:${key} refers to a channel that does not exist`,
                        },
                    };
                }),
            },
            {
                name: 'setMixerCrosspointMuteOrVolume',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/workingsettings\/dsp\/mixer\/config\/parameter\/(.+)$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    // Parameters are string values
                    const params = JSON.parse(req.data);
                    const key = match[1];
                    const myValue = params.value === 'true'
                        ? true
                        : params.value === 'false'
                            ? false
                            : parseInt(params.value, 10);
                    if (key in this.mixerConfig) {
                        this.mixerConfig[key].value = myValue;
                        return {
                            data: {
                                success: true,
                                data: {
                                    value: params.value,
                                },
                            },
                        };
                    }
                    return {
                        data: {
                            statusCode: 422,
                            error: 'Unprocessable Entity',
                            message: `(Error Code: undefined ) Error, id must contain valid mixer input channel parameter, IE: (Depth) from Mixer.1.InputChannel.2.Depth`,
                        },
                    };
                }),
            },
            {
                name: 'powerQuery',
                method: 'get',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/system\/frontPanel\/info\/power$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: [{ powerState: `${this.powerState ? 'On' : 'Off'}` }],
                    };
                    return { data: response };
                }),
            },
            {
                name: 'powerSet',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/simplecontrol\/system\/frontPanel\/info\/power$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const params = JSON.parse(req.data);
                    this.powerState = params.value.toUpperCase() === 'ON';
                    const response = {
                        success: true,
                        data: { powerState: `${this.powerState ? 'On' : 'Off'}` },
                    };
                    return { data: response };
                }),
            },
            {
                name: 'presetQuery',
                path: /:\d+\/v1\.0-beta\/preset$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: this.presets,
                    };
                    return { data: response };
                }),
            },
            {
                name: 'presetRecall',
                method: 'post',
                path: /:\d+\/v1\.0-beta\/preset\/recall\/(.+)$/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    return {
                        data: {
                            success: true,
                            data: {},
                        },
                    };
                }),
            },
            {
                name: 'systemInfo',
                path: /:\d+\/v1\.0-beta\/system\/info/i,
                callback: (match, req) => __awaiter(this, void 0, void 0, function* () {
                    const response = {
                        success: true,
                        data: [
                            {
                                id: 1,
                                name: 'Ashly Mixer Amp',
                                group: 'Default',
                                deviceType: this.modelNumber === ModelNumber.mxa1502 ? 'mXa-1502' : 'AQM-1208',
                                platformType: 'Ontario',
                                notes: 'Aveo Systems Emulator (https://aveosystems.com)',
                                softwareRevision: '1.2.25',
                                hardwareRevision: '1.0.0',
                            },
                        ],
                    };
                    return { data: response };
                }),
            },
        ];
    }
    onConfigure(config) {
        var _a;
        this.dspChannels.length = 0;
        this.dspBlockDefinitions.length = 0;
        this.blockLevels.length = 0;
        this.dspBlockDefinitions.length = 0;
        this.dspChannels.length = 0;
        this.presets.length = 0;
        this.modelNumber = (_a = config.modelNumber) !== null && _a !== void 0 ? _a : ModelNumber.mxa1502;
        if (this.modelNumber == ModelNumber.mxa1502) {
            this.createDSPChannels(this.channelConfigurations[ModelNumber.mxa1502]);
        }
        else if (this.modelNumber === ModelNumber.aqm1208) {
            this.createDSPChannels(this.channelConfigurations[ModelNumber.aqm1208]);
        }
    }
    // Creates the DSP channels based on the product definition
    createDSPChannels(channels) {
        let numberInputs = 0;
        let numberOutputs = 0;
        let numberMixes = 0;
        for (const [chanType, chanDef] of Object.entries(channels !== null && channels !== void 0 ? channels : {})) {
            if (chanType === 'input' ||
                chanType === 'stereoInput' ||
                chanType === 'ampOutput' ||
                chanType === 'lineOutput') {
                this.dspChannels.push(...this.makeChans(chanDef.idPrefix, chanDef.namePrefix, chanDef.type, chanDef.baseType, chanDef.start, chanDef.end));
                if (chanType === 'input' || chanType === 'stereoInput') {
                    numberInputs += chanDef.end - chanDef.start + 1;
                }
                if (chanType === 'lineOutput' || chanType === 'ampOutput') {
                    numberOutputs += chanDef.end - chanDef.start + 1;
                }
            }
            else if (chanType === 'preset') {
                for (let i = chanDef.start; i <= chanDef.end; i++) {
                    this.presets.push({ id: `Preset.${i}`, name: `Preset ${i}`, type: 'Preset' });
                }
            }
            else if (chanType === 'subMix') {
                numberMixes += chanDef.end - chanDef.start + 1;
            }
        }
        // Set all input and output channels unmuted.
        for (let i = 1; i <= numberInputs; i++) {
            const chanName = `InputChannel.${i}`;
            this.inputOutputMutes[chanName] = { muted: false };
        }
        for (let i = 1; i <= numberOutputs; i++) {
            const chanName = `OutputChannel.${i}`;
            this.inputOutputMutes[chanName] = { muted: false };
        }
        // Add a DSP gain block to each input and output.
        this.dspBlockDefinitions.push(...this.makeBlocks(numberInputs, numberOutputs));
        // set levels to 0 on dspBlockDefinitions.
        for (const dspBlock of this.dspBlockDefinitions) {
            this.blockLevels[`${dspBlock.id}.Level`] = 0;
        }
        // Configure crosspoint mutes.
        this.makeMixerConfig(numberMixes, numberInputs);
    }
    // Create a Gain block on each input signal chain in position 1
    makeBlocks(numInputs = 12, numOutputs = 4) {
        const blocks = [];
        for (let i = 1; i <= numInputs; i++) {
            blocks.push({
                id: `InputChannel.${i}.BlockPosition.1`,
                sequence: 1,
                isWorkingSettings: true,
                DSPChainId: `InputChannel.${i}`,
                DSPBlockTypeId: 'Gain',
            });
        }
        // Make a gain block in each output signal chain in position 6
        for (let i = 1; i <= numOutputs; i++) {
            blocks.push({
                id: `OutputChannel.${i}.BlockPosition.6`,
                sequence: 6,
                isWorkingSettings: true,
                DSPChainId: `OutputChannel.${i}`,
                DSPBlockTypeId: 'Gain',
            });
        }
        return blocks;
    }
    // Create the DSP input and output channels.
    makeChans(idPrefix, namePrefix, type, baseType, start, end, localIndex = false) {
        const chans = [];
        let j = 1;
        for (let i = start; i <= end; i++) {
            chans.push({
                id: `${idPrefix}.${i}`,
                defaultName: `${namePrefix} ${localIndex ? j : i}`,
                name: `${namePrefix} ${localIndex ? j : i}`,
                type: type,
                baseType: baseType,
                channelNumber: i,
            });
            j++;
        }
        return chans;
    }
    makeMixerConfig(numMixers = 4, numInputs = 12) {
        for (let mixer = 1; mixer <= numMixers; mixer++) {
            let id = `Mixer.${mixer}.Ducking Enabled`;
            this.mixerConfig[id] = {
                id: id,
                value: false,
                index: null,
                channelId: null,
                DSPMixerConfigId: `Mixer.${mixer}`,
                DSPMixerConfigParameterTypeId: 'Mixer.Ducking Enabled',
            };
            id = `Mixer.${mixer}.Global Automix Response`;
            this.mixerConfig[id] = {
                id: id,
                value: 0.1,
                index: null,
                channelId: null,
                DSPMixerConfigId: `Mixer.${mixer}`,
                DSPMixerConfigParameterTypeId: 'Mixer.Global Automix Response',
            };
            id = `Mixer.${mixer}.Name`;
            this.mixerConfig[id] = {
                id: id,
                value: `Mixer.${mixer}`,
                index: null,
                channelId: null,
                DSPMixerConfigId: `Mixer.${mixer}`,
                DSPMixerConfigParameterTypeId: 'Mixer.Name',
            };
            for (let input = 1; input <= numInputs; input++) {
                let id = `Mixer.${mixer}.InputChannel.${input}.Source Mute`;
                this.mixerConfig[id] = {
                    id: id,
                    value: false,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Source Mute',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Source Level`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 0,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Source Level',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Source Automix Enable`;
                this.mixerConfig[id] = {
                    id: id,
                    value: false,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Source Automix Enable',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Priority`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 1,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Priority',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Filibuster`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 'Off',
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Filibuster',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Depth`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 5,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Depth',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Release`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 50,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Release',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Trigger Threshold`;
                this.mixerConfig[id] = {
                    id: id,
                    value: -30,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Trigger Threshold',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Enabled`;
                this.mixerConfig[id] = {
                    id: id,
                    value: true,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Enabled',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Hold Time`;
                this.mixerConfig[id] = {
                    id: id,
                    value: 0,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Hold Time',
                };
                id = `Mixer.${mixer}.InputChannel.${input}.Source Enabled`;
                this.mixerConfig[id] = {
                    id: id,
                    value: true,
                    index: input,
                    channelId: `InputChannel.${input}`,
                    DSPMixerConfigId: `Mixer.${mixer}`,
                    DSPMixerConfigParameterTypeId: 'Mixer.Source Enabled',
                };
            }
        }
    }
}
AshlyMxaDsp.emulatorType = 'httpRequestEmulator';
AshlyMxaDsp.key = '-Ne3aDybJFMi5N0bsbJH';
